import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/folders.action'
import orderFolder from 'api/administration/folders/Order'
import foldersList from 'api/administration/folders/List'
import I18n from '../../../i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

async function getList() {
  return await foldersList()
}

async function handleEdit(idFolder: number, idTarget: number) {
  return await orderFolder(idFolder, idTarget)
}

function* orderFolderEffectSaga(action: any) {
  try {
    // FIRST EDIT THE FOLDER
    const { idFolder, idTarget } = action.payload

    yield call(handleEdit, idFolder, idTarget)

    // SECOND RELOAD DATA
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* orderFolderWatcherSaga() {
  yield takeLatest(fromActions.ORDER_FOLDER, orderFolderEffectSaga)
}
